import { compactStatusSummaryVariant, formatCompactStatusSummary } from "./status.js";
import "react";
import { Badge } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/instance/ActivityEvalStatusSummaryBadge.tsx
function ActivityEvalStatusSummaryBadge({ pending, statusSummary }) {
	if (!statusSummary || statusSummary.total === 0) return null;
	return /* @__PURE__ */ jsx(Badge, {
		value: formatCompactStatusSummary(statusSummary),
		variant: compactStatusSummaryVariant(statusSummary, { pending })
	});
}
//#endregion
export { ActivityEvalStatusSummaryBadge };

//# sourceMappingURL=ActivityEvalStatusSummaryBadge.js.map